const Realize = {
	InputAutocompleteOption: window.InputAutocompleteOption,
};

export default class InputAutocompleteOption extends Realize.InputAutocompleteOption{
	constructor(props){
		super(props);
		this.render = InputAutocompleteOption.prototype.render.bind(this);
	}

	render(){
		return (
			<li title={this.props.name} className={this.className()} onClick={this.handleSelect} onMouseEnter={this.handleMouseEnter}>
				<InputCheckbox id={this.parseOptionId()} checked={this.props.selected} onChange={this.disableEvent} onClick={this.disableEvent} key={this.generateUUID()} />
				<Label id={this.parseOptionId()} name={this.props.name} />  
			</li>
		);
	}

}
